<script lang="ts" setup>
import { computed } from 'vue';
import getSubDomainInitial from '../../helpers/getSubDomainInitial';
import HomeMX from './LandingMX/Home.vue';
import HomeAR from './LandingAR/Home.vue';
import HomeES from './LandingES/Home.vue';
import HomeCH from './LandingCH/Home.vue';
import HomeContempora from './LandingContempora/Home.vue';

const subDomainInitial = getSubDomainInitial();

const landings: Record<string, any> = {
  MEXICO: HomeMX,
  ARGENTINA: HomeAR,
  SPAIN: HomeES,
  CHILE: HomeCH,
  CONTEMPORA: HomeContempora,
};

const homeComponent = computed(() => landings[subDomainInitial] ?? HomeMX);
</script>

<template>
  <component :is="homeComponent" />
</template>
